import { Breakpoint } from '@mui/system';

import Button from '@mui/material/Button';
import MuiDialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

export interface IDialogActionsProps {
  value: string;
}

interface IDialogProps {
  open: boolean;
  title?: string;
  actions?: IDialogActionsProps[];
  onClose: () => void;
  maxWidth?: Breakpoint | false;
  description: string;
}

const Dialog = ({
  open,
  title,
  actions,
  onClose,
  maxWidth = 'sm',
  description,
}: IDialogProps) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <MuiDialog
      open={open}
      keepMounted
      onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth>
      {title && <DialogTitle>{title}</DialogTitle>}
      {description && (
        <DialogContent>
          <DialogContentText sx={{ textAlign: 'center', mt: 3 }}>
            {description}
          </DialogContentText>
        </DialogContent>
      )}
      {actions && (
        <DialogActions sx={{ mb: 2 }}>
          {actions.map(({ value }) => {
            return (
              <Button
                key={`${value}-action`}
                onClick={handleClose}
                variant="contained"
                size="large"
                sx={{ mr: 2 }}>
                {value}
              </Button>
            );
          })}
        </DialogActions>
      )}
    </MuiDialog>
  );
};

export default Dialog;
